// extracted by mini-css-extract-plugin
module.exports = {"sylabusComponent":"Sylabus_sylabusComponent__3K4t4","carouselItemTitle":"Sylabus_carouselItemTitle__3-roF","owl-item":"Sylabus_owl-item__3VwhN","item":"Sylabus_item__1_kF5"};